import { topicsData } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          当前最受关注的娱乐话题，实时热度排序
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#carousel"
              className="group flex flex-col items-center gap-2 p-4 md:p-5 bg-background-50 hover:bg-background-200/60 border border-background-200/60 hover:border-primary-500/30 rounded-lg transition-all duration-200 cursor-pointer"
            >
              <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-400 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                <i className={`${topic.icon} text-lg md:text-xl`}></i>
              </span>
              <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-foreground-950 whitespace-nowrap">
                {topic.name}
              </span>
              <span className="flex items-center gap-1.5">
                <span className="text-xs bg-accent-100 text-accent-700 px-1.5 py-0.5 rounded">{topic.tag}</span>
                <span className="text-xs text-foreground-500">{topic.heat}</span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}